import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import MuiToolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';

export interface TitleBarTab {
  path: string;
  label: ReactNode;
  disabled?: boolean;
}

export interface TitleBarProps {
  actions?: ReactNode;
  title?: ReactNode;
  dateRangePicker?: ReactNode;
  tabs?: TitleBarTab[];
}

const TitleBar = ({ actions, title, dateRangePicker, tabs }: TitleBarProps) => {
  const { pathname } = useLocation();
  const activeTab = tabs?.find(tab => tab.path.split('?')[0] === pathname)?.path ?? false;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <MuiAppBar position="static" enableColorOnDark color="default" sx={{ backgroundColor: 'surface.2' }}>
        <MuiToolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Typography variant="h5">{title}</Typography>
            {dateRangePicker}
          </Box>
          <Box>{actions}</Box>
        </MuiToolbar>
        {tabs && (
          <Tabs value={activeTab}>
            {tabs.map(({ path, label, disabled }) => (
              <Tab key={path} value={path} label={label} disabled={disabled} component={Link} to={path} />
            ))}
          </Tabs>
        )}
      </MuiAppBar>
    </Box>
  );
};

export default TitleBar;
